export default __webpack_public_path__ + "static/media/ZeroTime_Logo_Error_Pages.4d26d297.svg";